import { render, staticRenderFns } from "./HighPressure.vue?vue&type=template&id=123f84d9&"
import script from "./HighPressure.vue?vue&type=script&lang=js&"
export * from "./HighPressure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports